import React, { MouseEvent } from 'react';
import { RoundedButton } from '@trevor/ui-components';
import AggregateFunction from '@/util/AggregateFunction';

export type CustomizeAggregationButtonProps = {
  aggregateFunction: AggregateFunction;
  openModal: F<AggregateFunction>;
};

export const CustomizeAggregationButton: React.FC<
  CustomizeAggregationButtonProps
> = ({ aggregateFunction, openModal }) => {
  const openCustomizeModal = (e: MouseEvent) => {
    openModal(aggregateFunction);
    e.preventDefault();
  };
  return (
    <RoundedButton
      $borderRadius="50px"
      $height="23px"
      $width="86px"
      onClick={openCustomizeModal}
    >
      Customize
    </RoundedButton>
  );
};
